var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGeometricGlobe = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 30,
    viewBox: "0 0 30 30",
    width: 30,
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.37778
  }, /*#__PURE__*/React.createElement("path", {
    d: "m15.0002 27.5c6.9036 0 12.5-5.5964 12.5-12.5 0-6.90356-5.5964-12.5-12.5-12.5-6.90351 0-12.49996 5.59644-12.49996 12.5 0 6.9036 5.59645 12.5 12.49996 12.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.2356 15.7363h23.5294"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.0006 27.5c2.8426 0 5.147-5.5964 5.147-12.5 0-6.90356-2.3044-12.5-5.147-12.5-2.8427 0-5.14708 5.59644-5.14708 12.5 0 6.9036 2.30438 12.5 5.14708 12.5z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGeometricGlobe);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/geometric-globe.87ed6a9e717e157736c13de3f666b3e7.svg";